import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'components/common/Button';

export default function FormDialog({ onClose, onSubmit }) {
  const [email, setEmail] = useState('');

  return (
    <Dialog open onClose={onClose} disableBackdropClick>
      <DialogTitle>Set iCloud Email address</DialogTitle>
      <DialogContent>
        <DialogContentText color={'textPrimary'}>
          <Typography gutterBottom>
            You've connected with iCloud account but your Apple ID is not an
            iCloud email address. iCloud email address should end with
            @icloud.com or @me.com.
          </Typography>
          <Typography gutterBottom>
            If you're on iPhone you can see this by going to Settings->Your
            Apple ID at the top->iCloud->Mail (at the bottom), and your iCloud
            emails will be listed.
          </Typography>
          <Typography>
            Alternatively, visit{' '}
            <a target="_blank" href="https://appleid.apple.com/account/manage">
              AppleID
            </a>{' '}
            page.
          </Typography>
        </DialogContentText>
        <TextField
          autoFocus
          margin="normal"
          label="Email Address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={!email}
          onClick={() => onSubmit(email)}
          color="primary"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
